import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from '../shared/components/layout/Navbar';
import ProtectedRoute from '../shared/components/layout/ProtectedRoute';
import Login from '../auth/Login';
import ForgotPassword from '../auth/ForgotPassword';
import AppRoutes from './AppRoutes';
import useAdminReportSocket from './hooks/useAdminReportSocket';
import useUserStore from '../store/user-store';
import { setUnauthorizedHandler } from '../store/api/apiClient';
import '../App.css';

const AppShell = () => {
  const location = useLocation();
  const showNavbar = location.pathname !== '/login' && location.pathname !== '/reset-password';
  const bootstrapSession = useUserStore((state) => state.bootstrapSession);
  const clearUser = useUserStore((state) => state.clearUser);

  useAdminReportSocket();

  useEffect(() => {
    bootstrapSession();
  }, [bootstrapSession]);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      clearUser();
      window.location.assign('/login');
    });
  }, [clearUser]);

  useEffect(() => {
    window.Intercom?.('update');
  }, [location]);

  return (
    <>
      {showNavbar && <Navbar />}
      <div className={`max-w-screen-3xl mx-auto ${showNavbar ? 'px-6' : ''}`}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ForgotPassword />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppRoutes />
              </ProtectedRoute>
            }
          />
        </Routes>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

const App = () => (
  <Router>
    <AppShell />
  </Router>
);

export default App;
